import { render, staticRenderFns } from "./GsaSelection.vue?vue&type=template&id=0c509448&scoped=true"
import script from "./GsaSelection.vue?vue&type=script&lang=js"
export * from "./GsaSelection.vue?vue&type=script&lang=js"
import style0 from "./GsaSelection.vue?vue&type=style&index=0&id=0c509448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c509448",
  null
  
)

export default component.exports